import { Loader } from '@googlemaps/js-api-loader';
import { mapStyle } from './map-style.js';

const loader = new Loader({
 apiKey: googlemap_scripts.apiKey,
 version: 'weekly',
});

export async function loadGoogleMaps() {
 try {
  const google = await loader.load();
  const googleMapElem = document.querySelector('#google-map');
  if (!googleMapElem) return;

  googleMapElem.style.display = 'block';

  const mapHeight = googlemap_scripts.heightMap || '340px';
  googleMapElem.style.height = mapHeight;

  const zoomLevel = parseInt(googleMapElem.dataset.zoom, 10) || 14;

  const mapOptions = {
   center: {
    lat: parseFloat(googleMapElem.dataset.latitude),
    lng: parseFloat(googleMapElem.dataset.longitude)
   },
   mapTypeId: google.maps.MapTypeId.ROADMAP,
   zoom: zoomLevel,
   styles: JSON.parse(googlemap_scripts.mapStyleGm),
  };

  const map = new google.maps.Map(googleMapElem, mapOptions);
  const locations = JSON.parse(googleMapElem.dataset.locations || '[]');
  const markers = {};
  const bounds = new google.maps.LatLngBounds();
  const globalMarkerIcon = googleMapElem.dataset.defaultMarker;

  locations.forEach(location => {
   const marker = new google.maps.Marker({
    position: { lat: parseFloat(location.lat), lng: parseFloat(location.lng) },
    map: map,
    icon: globalMarkerIcon,
    title: location.city || '',
   });

   const infoWindow = new google.maps.InfoWindow({
    content: `
                    <div class="info-window">
                        <p>${location.streetNumber} ${location.streetName}<br>
                        ${location.postcode} ${location.city}</p>
                    </div> 
                `,
   });

   marker.addListener('click', () => {
    infoWindow.open(map, marker);
   });

   markers[location.id] = { marker, infoWindow };
   bounds.extend(marker.getPosition());
  });

  if (locations.length > 1) {
   map.fitBounds(bounds);
  } else if (locations.length === 1) {
   map.setCenter({
    lat: parseFloat(locations[0].lat),
    lng: parseFloat(locations[0].lng),
   });
   map.setZoom(zoomLevel);
  }

  // Interactions avec autres blocs
  document.querySelectorAll('.bloc-marches').forEach(item => {
   item.addEventListener('click', function () {
    const filialeId = this.dataset.filialeId;
    if (markers[filialeId]) {
     const target = markers[filialeId].marker;
     map.setCenter(target.getPosition());
     map.setZoom(zoomLevel);
     markers[filialeId].infoWindow.open(map, target);
    }

    googleMapElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
   });
  });

 } catch (e) {
  console.error('Erreur lors du chargement de Google Maps', e);
 }
}

// Charge la carte uniquement au clic sur le bouton
document.addEventListener('DOMContentLoaded', () => {
 const showMapBtn = document.querySelector('#show-map-btn');
 const placeholder = document.querySelector('#map-placeholder');

 showMapBtn?.addEventListener('click', async () => {
  if (placeholder) placeholder.style.display = 'none';
  showMapBtn.style.display = 'none';
  await loadGoogleMaps();
 });
});
